import {
	RESET_STATE,
	SET_PLANNINGS_PROCESS_LIST,
	SET_IS_PLANNINGS_PROCESS_LIST_LOADING,
	SET_PAGINATION,
	SET_CONFIGS,
	SET_IS_CONFIGS_LOADING,
	SET_PROCESS_INFO,
	SET_IS_PROCESS_INFO_LOADING,
	SET_IS_PLANNING_SELECTED,
	SET_COLLECTION_LIST,
	SET_IS_COLLECTION_LIST_LOADING,
	RESET_IS_COLLECTION_LIST_LOADING,
	SET_MODES,
	SET_IS_MODES_LOADING,
	SET_PLANNING_OPEN,
} from './actions';

export const initialState = {
	planningsProcessList: null,
	isPlanningsProcessListLoading: false,
	processInfo: null,
	isProcessInfoLoading: false,
	pagination: null,
	configs: null,
	isConfigsLoading: false,
	isPlanningSelected: false,
	collectionList: {},
	isCollectionListLoading: [],
	modes: null,
	isModesLoading: false,
	planningOpen: null,
};

const planningsProcessContainerReducer = (state = initialState, action) => {
	const { type, payload } = action;

	switch (type) {
		case SET_PLANNINGS_PROCESS_LIST:
			return {
				...state,
				planningsProcessList: payload,
			};
		case SET_IS_PLANNINGS_PROCESS_LIST_LOADING:
			return {
				...state,
				isPlanningsProcessListLoading: payload,
			};
		case SET_PROCESS_INFO:
			return {
				...state,
				processInfo: payload,
			};
		case SET_IS_PROCESS_INFO_LOADING:
			return {
				...state,
				isProcessInfoLoading: payload,
			};
		case SET_PAGINATION:
			return {
				...state,
				pagination: payload,
			};
		case SET_CONFIGS:
			return {
				...state,
				configs: payload,
			};
		case SET_IS_CONFIGS_LOADING:
			return {
				...state,
				isConfigsLoading: payload,
			};
		case SET_IS_PLANNING_SELECTED:
			return {
				...state,
				isPlanningSelected: payload,
			};
		case SET_COLLECTION_LIST:
			return {
				...state,
				collectionList: payload,
			};
		case SET_IS_COLLECTION_LIST_LOADING:
			return { ...state, isCollectionListLoading: [...state.isCollectionListLoading, action.payload] };
		case RESET_IS_COLLECTION_LIST_LOADING:
			return {
				...state,
				isCollectionListLoading: state.isCollectionListLoading.filter(el => el !== action.payload),
			};
		case SET_MODES:
			return {
				...state,
				modes: payload,
			};
		case SET_IS_MODES_LOADING:
			return {
				...state,
				isModesLoading: payload,
			};
		case SET_PLANNING_OPEN:
			return {
				...state,
				planningOpen: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default planningsProcessContainerReducer;
